import type { IconData } from '@stacksjs/iconify-core'

export const quote: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5 0a1 1 0 1 1 0 2c-.893 0-1.695.39-2.245 1.01A3 3 0 1 1 0 6V5a5 5 0 0 1 5-5m8 0a1 1 0 0 1 0 2c-.893 0-1.695.39-2.245 1.01A3 3 0 1 1 8 6V5a5 5 0 0 1 5-5M3 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2m8 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2\"/>",
  "width": 14,
  "height": 9,
  "viewBox": "0 0 14 9"
}

export default quote
